import { CognitoUserPool } from "amazon-cognito-identity-js";
import config from "../config";
import AWS from "aws-sdk";
import sigV4Client from "./sigV4Client";
import Amplify, { Auth, Storage } from "aws-amplify";

const uuidv4 = require('uuid/v4');

const ts_app_gateway_url = process.env.REACT_APP_API_GATEWAY_URL;       // config.apiGateway.URL
const ts_app_gateway_region = process.env.REACT_APP_API_GATEWAY_REGION; // config.apiGateway.REGION,

const ts_app_client_id    = process.env.REACT_APP_API_GATEWAY_APP_CLIENT_ID;    //config.cognito.APP_CLIENT_ID
const ts_cognito_region   = process.env.REACT_APP_API_GATEWAY_REGION;           //config.cognito.REGION
const ts_user_pool_id     = process.env.REACT_APP_API_GATEWAY_USER_POOL_ID;     //config.cognito.USER_POOL_ID
const ts_identity_pool_id = process.env.REACT_APP_API_GATEWAY_IDENTITY_POOL_ID; //config.cognito.IDENTITY_POOL_ID

/**********  DEV BUCKET  **********
const identity_pool_id =  'us-west-2:c9d67ee1-ecb3-455d-8ba0-d5567a9e9f6d' //Specify your identityPoolId for Auth and Unauth access to your bucket;

/**********  PROD BUCKET  **********/
////  below stage_bucket only contains profile photos, no document or assessment images/files
const identity_pool_id = 'us-west-2:0e9ebcd7-1123-413f-bfa9-9b2bc3aae62d' //Specify your identityPoolId for Auth and Unauth access to your bucket;
/* */

export async function authUser() {
    if (AWS.config.credentials && Date.now() < AWS.config.credentials.expireTime - 60000) {
        //console.log("AWSLib.js Check login expire time: " + AWS.config.credentials.expireTime);
        return true;
    }

    const currentUser = getCurrentUser();

    if (currentUser === null) {
        return false;
    }

    const userToken = await getUserToken(currentUser);

    await getAwsCredentials(userToken);

    return true;
}

export async function s3Delete(document_id) {
    const status = await Storage.vault.remove(document_id)
           .then(result => {
               return true;
           })
           .catch(err => {
               console.log("Err: " + err)
               return null;
           });

    return {status: status};
}


export async function s3PublicUpload(bucket_name, file) {

    var bucket;// = stage_bucket;

    if(bucket_name === "messenger_files") {
        bucket = "ts-admin-prod-messenger-files"  // prod //bucket = "ts-admin-dev-messenger-files" // dev
        console.log("Send file to messenger files");
    } else if(bucket_name === "progress-photos") {
        bucket = "ts-athlete-prod-progress-photos"
        console.log("Send images to progress bucket");
    }



    // Specify public bucket //
    Storage.configure({
        bucket: bucket,//Your bucket ARN;
        region: 'us-west-2',//Specify the region your bucket was created in;
        identityPoolId: identity_pool_id
    });

    const filename = uuidv4();

    const stored = await Storage.put(filename, file, {
            bucket: bucket,
            contentType: file.type
        })
        .then (result => {
            return result.key;
        })
        .catch(err => {
            console.log(err)
        });

    //return stored.key;
    return stored;
}

export async function invokeApig({
      path,
      method = "OPTIONS", //"GET",
      headers = {
          /*"Access-Control-Allow-Origin" : "*",
          "Access-Control-Allow-Credentials" : true,
          "Content-Type": "application/json"*/
      },
      queryParams = {},
      body
    }) {
      if (!await authUser()) {
        throw new Error("User is not logged in");
      }

      const signedRequest = sigV4Client
        .newClient({
          accessKey: AWS.config.credentials.accessKeyId,
          secretKey: AWS.config.credentials.secretAccessKey,
          sessionToken: AWS.config.credentials.sessionToken,
          region:   ts_app_gateway_region, //config.apiGateway.REGION,
          endpoint: ts_app_gateway_url, //config.apiGateway.URL
        })
        .signRequest({
          method,
          path,
          headers,
          queryParams,
          body
        });

      body = body ? JSON.stringify(body) : body;
      headers = signedRequest.headers;

      const results = await fetch(signedRequest.url, {
        method,
        headers,
        body
      });

      if (results.status !== 200) {
        throw new Error(await results.text());
      }

      return results.json();
}

function getUserToken(currentUser) {
  return new Promise((resolve, reject) => {
    currentUser.getSession(function(err, session) {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

export function signOutUser() {
  const currentUser = getCurrentUser();

  if (currentUser !== null) {
    currentUser.signOut();
  }

  if (AWS.config.credentials) {
    AWS.config.credentials.clearCachedId();
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({});
  }
}

export async function s3Upload(file) {
  if (!await authUser()) {
    throw new Error("User is not logged in");
  }

  const s3 = new AWS.S3({
    params: {
      Bucket: config.s3.BUCKET
    }
  });
  const filename = `${AWS.config.credentials
    .identityId}-${Date.now()}-${file.name}`;

  return s3
    .upload({
      Key: filename,
      Body: file,
      ContentType: file.type,
      ACL: "public-read"
    })
    .promise();
}

function getAwsCredentials(userToken) {
  // const authenticator = 'cognito-idp.${config.cognito.REGION}.amazonaws.com/${config.cognito.USER_POOL_ID}';
  // Inexplicably, must use single quotes like below otherwise this CONST isn't valid;
  // i.e. above CONST is not valid

  const authenticator = `cognito-idp.${ts_cognito_region}.amazonaws.com/${ts_user_pool_id}`;

  AWS.config.update({ region: ts_cognito_region }); //config.cognito.REGION

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: ts_identity_pool_id,
    Logins: {
      [authenticator]: userToken
    }
  });

  return AWS.config.credentials.getPromise();
}

function getCurrentUser() {

  const userPool = new CognitoUserPool({
      UserPoolId: ts_user_pool_id, //config.cognito.USER_POOL_ID,
      ClientId:   ts_app_client_id //config.cognito.APP_CLIENT_ID
  });

  var cognitoUser = userPool.getCurrentUser();

  /*gives an error: cognitoUser.getUserAttributes(function(err, result) {
      if (err) {
          alert(err);
          return;
      }
      for (var i = 0; i < result.length; i++) {
          console.log('attribute ' + result[i].getName() + ' has value ' + result[i].getValue());
      }
  });/* */

  return cognitoUser;
}



// WEBPACK FOOTER //
// ./src/libs/awsLib.js